import { ApplicationsTable } from '~widgets/applications-table';

export const LoansPage = () => <ApplicationsTable />;
